import React from "react";
import { connect } from "react-redux";
import { Divider, Header, Image } from "semantic-ui-react";

// import { checkRoles } from 'core/utilities';
import { AdminContainer, MenuButton } from "./styled";
import { MainBodyContent } from "components";
import {
  prMainSupportForUserPath,
  grMainSupportForUserPath,
  roleMainSupportForUserPath,
} from "routes";

const SupportContainer = (props) => {
  const { history } = props;

  React.useState(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainBodyContent headerTitle="Support">
      <AdminContainer>
        <React.Fragment>
          <div className="titleText">Procurement System</div>
          <Divider />
          <div className="secment system">
            <MenuButton
              title="Purchase Requisition (PR)"
              onClick={() => history.push(prMainSupportForUserPath)}
            />
            <MenuButton
              title="Goods/Service Receipt (GR)"
              onClick={() => history.push(grMainSupportForUserPath)}
            />
          </div>
          <div className="titleText">Report</div>
          <Divider />
          <div className="secment system">
            <MenuButton
              title="Role K2"
              onClick={() => history.push(roleMainSupportForUserPath)}
            />
            <MenuButton
              title="GR/Billing Report"
              onClick={() => history.push(roleMainSupportForUserPath)}
            />
          </div>
        </React.Fragment>
      </AdminContainer>
    </MainBodyContent>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SupportContainer);
